import React from "react";

import { useTheme } from "@mui/material/styles";

const CheckMark = ({ color, size = 24 }) => {
  const theme = useTheme();
  const c = color || theme.palette.secondary.main;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>CheckMark</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Landing-page" transform="translate(-71.000000, -440.000000)">
          <g
            id="Group-2"
            transform="translate(71.000000, 440.000000)"
            fill="#FFFFFF"
          >
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="29"
              height="28"
              rx="7"
            ></rect>
          </g>
          <polyline
            id="Path-8"
            stroke={c}
            strokeWidth="3.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="80 454 83.8308566 458 91 450"
          ></polyline>
        </g>
        <g id="V01-" transform="translate(-912.000000, -1755.000000)"></g>
      </g>
    </svg>
  );
};

export default CheckMark;
